import gql from "graphql-tag";

export const QueryGetAnalysis = gql(`
query(
    $assessmentId: ID!
    $analysisId: String!
) {
    getAnalysis(
        assessmentId: $assessmentId
        analysisId: $analysisId
    ) {
        assessmentId
        analysisId
        date
        handSide
        type
        coloursLT
        coloursLB
        coloursRT
        coloursRB
        noteTitleLT
        noteTitleLB
        noteTitleRT
        noteTitleRB
    	noteContentLT
        noteContentLB
        noteContentRT
        noteContentRB
        created
        updated
    }
}`);

export const MutationCreateAnalysis = gql(`
mutation(
    $assessmentId: ID!
    $analysisId: String!
    $createdBy: String
    $date: String!
    $handSide: String!
    $type: String
    $coloursLT: String
    $coloursLB: String
    $coloursRT: String
    $coloursRB: String
    $noteTitleLT: String
    $noteTitleLB: String
    $noteTitleRT: String
    $noteTitleRB: String
    $noteContentLT: String
    $noteContentLB: String
    $noteContentRT: String
    $noteContentRB: String
    $created: String
    $updated: String
) {
    createAnalysis(input: {
        assessmentId: $assessmentId
        analysisId: $analysisId
        createdBy: $createdBy
        date: $date
        handSide: $handSide
        type: $type
        coloursLT: $coloursLT
        coloursLB: $coloursLB
        coloursRT: $coloursRT
        coloursRB: $coloursRB
        noteTitleLT: $noteTitleLT
        noteTitleLB: $noteTitleLB
        noteTitleRT: $noteTitleRT
        noteTitleRB: $noteTitleRB
        noteContentLT: $noteContentLT
        noteContentLB: $noteContentLB
        noteContentRT: $noteContentRT
        noteContentRB: $noteContentRB
        created: $created
        updated: $updated
    }) {
        assessmentId
        analysisId
    	date
    	handSide
    	type
        coloursLT
        coloursLB
        coloursRT
        coloursRB
        noteTitleLT
        noteTitleLB
        noteTitleRT
        noteTitleRB
    	noteContentLT
        noteContentLB
        noteContentRT
        noteContentRB
    	created
    	updated
    }
}`);

export const MutationUpdateAnalysis = gql(`
mutation(
    $assessmentId: ID!
    $analysisId: String!
    $date: String
    $handSide: String
    $type: String
    $coloursLT: String
    $coloursLB: String
    $coloursRT: String
    $coloursRB: String
    $noteTitleLT: String
    $noteTitleLB: String
    $noteTitleRT: String
    $noteTitleRB: String
    $noteContentLT: String
    $noteContentLB: String
    $noteContentRT: String
    $noteContentRB: String
    $created: String
    $updated: String
) {
    updateAnalysis(input: {
        assessmentId: $assessmentId
        analysisId: $analysisId
        date: $date
        handSide: $handSide
        type: $type
        coloursLT: $coloursLT
        coloursLB: $coloursLB
        coloursRT: $coloursRT
        coloursRB: $coloursRB
        noteTitleLT: $noteTitleLT
        noteTitleLB: $noteTitleLB
        noteTitleRT: $noteTitleRT
        noteTitleRB: $noteTitleRB
        noteContentLT: $noteContentLT
        noteContentLB: $noteContentLB
        noteContentRT: $noteContentRT
        noteContentRB: $noteContentRB
        created: $created
        updated: $updated
    }) {
        assessmentId
    	analysisId
    	date
    	handSide
    	type
        coloursLT
        coloursLB
        coloursRT
        coloursRB
        noteTitleLT
        noteTitleLB
        noteTitleRT
        noteTitleRB
    	noteContentLT
        noteContentLB
        noteContentRT
        noteContentRB
    	created
    	updated
    }
}`);

// Assessments List
export const QueryAnalysisList = gql(`
query getAssessment($therapistId: ID! $assessmentId: String!) {
    getAssessment(
        therapistId: $therapistId
        assessmentId: $assessmentId
    ) {
        firstName
        lastName
        analysis {
          items {
            assessmentId
            analysisId
            date
            handSide
            type
            noteTitleLT
            noteTitleLB
            noteTitleRT
            noteTitleRB
            created
          }
        }
    }
}`);

export const MutationDeleteAnalysis = gql(`
mutation(
    $assessmentId: ID!
    $analysisId: String!
) {
    deleteAnalysis(input: {
        assessmentId: $assessmentId
        analysisId: $analysisId
    }) {
        __typename
    }
}`);
